module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resultsView"
  }, [(_vm.selectedMetricCategory !== null && _vm.selectedCommunitiesCount !== 0) ? _c('div', [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display) + " for Selected Communities")]), _vm._v(" "), _c('div', {
    staticClass: "sticky_div_table"
  }, [_c('div', {
    staticClass: "metricname_column"
  }, [_c('div', {
    staticClass: "metric_label_header"
  }, [_vm._v("Metric Name")]), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel) {
    return _c('div', {
      staticClass: "metric_label valign-wrapper"
    }, [_vm._v(_vm._s(metricLabel.display_name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "result_rows_container"
  }, [_c('div', {
    staticClass: "rows"
  }, [_c('div', {
    staticClass: "headers"
  }, _vm._l((_vm.selectedCommunities), function(community) {
    return (community.name in _vm.communityMetrics) ? _c('div', [_vm._v(_vm._s(community.name)), _c('i', {
      staticClass: "material-icons contribute-icon",
      attrs: {
        "title": "Contribute Data"
      },
      on: {
        "click": function($event) {
          return _vm.contributeDataClick(community)
        }
      }
    }, [_vm._v("add_circle_outline")])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel) {
    return _c('div', {
      staticClass: "content-row"
    }, _vm._l((_vm.selectedCommunities), function(community) {
      return (community.name in _vm.communityMetrics) ? _c('div', {
        staticClass: "center-align",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Click for Details"
        },
        on: {
          "click": function($event) {
            return _vm.indicatorClick(metricLabel, community, _vm.communityMetrics[community.name][_vm.selectedMetricCategory.name][metricLabel.name])
          }
        }
      }, [_c('data-availability-indicator', {
        attrs: {
          "score": _vm.communityMetrics[community.name][_vm.selectedMetricCategory.name][metricLabel.name].score
        }
      })], 1) : _vm._e()
    }), 0)
  })], 2)])])]) : _c('div', [_c('h5', {
    staticClass: "center-align"
  }, [_vm._v("Select one or more communities above to view metrics")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingCommunities),
      expression: "pendingCommunities"
    }],
    staticClass: "results-overlay center-align"
  }, [_c('h3', [_vm._v("Loading Additional Communities")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal bottom-sheet",
    attrs: {
      "id": "metadata-modal"
    }
  }, [(_vm.metadataCommunity != null) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.metadataMetric.display_name))]), _vm._v(" "), _c('p', [_vm._v("Data Resolution: " + _vm._s(_vm.metadataMetric.data_temporality))]), _vm._v(" "), _c('p', [_vm._v("Data Availability Range: " + _vm._s(_vm.metadataCommunityMetric.data_availability_range))]), _vm._v(" "), _c('p', [_vm._v("Data Format: " + _vm._s(_vm.metadataMetric.available_formats))]), _vm._v(" "), _c('p', [_vm._v("View data set filtered for "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.metadataCommunityMetric.dataset_link
    }
  }, [_vm._v(_vm._s(_vm.metadataCommunity.name))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "contribute-data-modal"
    }
  }, [(_vm.contributeCommunity != null) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', [_vm._v("Contribute Data for " + _vm._s(_vm.contributeCommunity.name))]), _vm._v(" "), _c('p', [_vm._v("Thank you for your interest in contributing data to the Alaska Energy Data Gateway. Please select any of the datasets\n      listed below that you'd like to contribute data towards, or select other and provide some details about your data.")]), _vm._v(" "), _c('p', [_vm._v("An administrator will contact you about your data.")]), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel, index) {
    return _c('ul', {
      attrs: {
        "id": "contribute-data-metric-list"
      }
    }, [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'metric_' + _vm.selectedMetricCategory.name + '_' + metricLabel.name,
        "type": "checkbox"
      }
    }), _c('label', {
      attrs: {
        "for": 'metric_' + _vm.selectedMetricCategory.name + '_' + metricLabel.name
      }
    }, [_vm._v(_vm._s(metricLabel.display_name))])])
  }), _vm._v(" "), _c('textarea', {
    staticClass: "materialize-textarea",
    attrs: {
      "id": "otherData",
      "name": "other_data_details",
      "placeholder": "Please describe any other data you'd like to contribue."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "contributeName",
      "placeholder": "Your Name..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "contributeEmail",
      "placeholder": "Your email..."
    }
  }), _vm._v(" "), (_vm.contributeError) ? _c('p', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.contributeErrorText))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn waves-effect blue darken-4 left",
    on: {
      "click": _vm.submitContribute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn modal-action modal-close waves-effect red",
    attrs: {
      "href": "#!"
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper big active"
  }, [_c('div', {
    staticClass: "spinner-layer spinner-blue-only"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4aa5538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultsList.vue
// module id = 150
// module chunks = 1